import { render } from "./VsdcServerSettings.vue?vue&type=template&id=1e083f4c&scoped=true"
import script from "./VsdcServerSettings.vue?vue&type=script&lang=js"
export * from "./VsdcServerSettings.vue?vue&type=script&lang=js"

import "./VsdcServerSettings.vue?vue&type=style&index=0&id=1e083f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e083f4c"]])

export default __exports__